/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Demo_Library_LabelInputs */

const en_mcp_demo_library_label = /** @type {(inputs: Mcp_Demo_Library_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Listening library`)
};

const es_mcp_demo_library_label = /** @type {(inputs: Mcp_Demo_Library_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu biblioteca de Listening`)
};

/**
* | output |
* | --- |
* | "Your Listening library" |
*
* @param {Mcp_Demo_Library_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_demo_library_label = /** @type {((inputs?: Mcp_Demo_Library_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Demo_Library_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_demo_library_label(inputs)
	return en_mcp_demo_library_label(inputs)
});